var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 160,
    viewBox: "0 0 1080 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_172_3418)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -181,
    width: 1442,
    height: 160,
    fill: "url(#paint0_linear_172_3418)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_172_3418",
    x: -181,
    y: 0,
    width: 1442,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.25 1.25",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 628
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_172_3418"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_3418",
    x1: 540,
    y1: 160,
    x2: 540,
    y2: -0.00000447035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFEBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDACE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBar);
export default __webpack_public_path__ + "static/media/bottom_bar.de02e6ca865d83cb2e0a84cc61d71401.svg";
export { ForwardRef as ReactComponent };